module.exports = __webpack_public_path__ + "static/media/daging.459eb9aa.svg";